import { Alert, NavigationLink } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';

/**
 * Why a quoting-dependent control is inert, linking to the plan page when the billing plan
 * excludes quoting and to general settings when it's merely switched off.
 */
export function QuotingUnavailableAlert({
  isRestricted,
  title,
  description,
}: {
  /** Plan excludes quoting, rather than it merely being switched off. */
  isRestricted: boolean;
  title: string;
  description: string;
}) {
  const { navigationHandler } = useHandlers();

  return (
    <Alert variant="info" title={title} headingLevel="h3">
      <div className="flex flex-col items-start gap-2">
        <span>{description}</span>
        <NavigationLink
          onClick={() =>
            isRestricted
              ? navigationHandler.navigateById('plan', {
                  newTab: true,
                })
              : navigationHandler.navigate('/configuration/general', {
                  openInDashboard: true,
                  newTab: true,
                })
          }
        >
          {t(isRestricted ? 'links:upgrade_plan' : 'links:go_to_settings')}
        </NavigationLink>
      </div>
    </Alert>
  );
}
